import { css } from "styled-components"
import * as fontIconsFontFace from "bnppf-font-icons"

const fontIcons = css`
  ${fontIconsFontFace}
`

export default fontIcons
